import React from "react";
import Icon from "./Icon";

const SelectCross = ({ onClick, title, icon }) => {
  return (
    <div
      style={{
        backgroundColor: "#F5F5F5",
        overflow: "hidden",
        alignItems: "center",
        padding: "7px 16px 7px 16px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: "1px solid #C8C8C8",
      }}
      onClick={onClick && onClick}
    >
      <text
        style={{
          fontFamily: "Roboto-Regular",
          fontSize: "14px",
          color: "#060808",
        }}
      >
        {title}
      </text>
      <div style={{ display: "flex" }}>
        <Icon icon={icon ?? "circleCross"} />
      </div>
    </div>
  );
};

export default SelectCross;
